<div
  style="overflow: hidden; margin-left: 10px; position: relative"
  [ngStyle]="{ 'height': bodyHeight, 'width': bodyWidth }">
  <google-map
    width="100%"
    height="95%"
    [center]="center"
    [zoom]="zoom"
    [options]="options"
    (centerChanged)="onCenterChange($event)"
    (mapInitialized)="handleMapInit()"
    (mapClick)="onMapClick($event)">
    @if (!!selectedPin) {
      <map-marker
        [position]="selectedPin?.position"
        [options]="selectedPin?.options"
      (mapDragend)="onDragend(selectedPin, $event)"></map-marker>
    }
  </google-map>
  @if (selectedAddress) {
    <div
      class="address">
      <i class="icon icon-pin"></i>
      {{ selectedAddress }}
    </div>
  }
  <div class="search-area">
    <topo-address-search
      [location]="sendLocation"
      [expandable]="true"
      [width]="'350px'"
    (searchResultChanged)="onSearchResultChanged($event)"></topo-address-search>
  </div>
  @if (selectedPin) {
    <div class="go-to-selected"
      [title]="'MAP.FIND-MY-LOCATION' | translate"
      (click)="onGoToSelected()">
      <i class="icon icon-crosshairs"></i>
    </div>
  }
</div>
